
export function themeGroup () { return "form-group m-3" }
export function themeGroupM3 () { return "form-group m-3" }
export function themeEditButton() { return "btn btn-info btn-sm" }
export function themeBackButton() { return "btn btn-info" }
export function themeSaveButton() { return "btn btn-success" }
export function themeUpdateButton() { return "btn btn-primary" }
export function themeDeleteButton() { return "btn btn-danger btn-sm" }
export function themeNewButton() { return "btn btn-info" }
export function themeExpandButton() { return "btn btn-success btn-sm" }
export function themeStripedTable() {return "table table-striped"}
export function themeSpinner() {return "fa fa-refresh fa-spin"}
export function themeFormInput() {return "form-control"}
export function themeCol3() {return "col-3"}
export function themeCol4() {return "col-4"}
export function themeCol6() {return "col-6"}
export function themeCol6Right() {return "col-6 text-right"}
export function themeCol9() {return "col-9"}
export function themeCol12xl() { return "col-xl-12" }

       
    
    